import { oauthButtonHandler } from "./oauth-utils";

document.addEventListener('script-loaded:apple', () => {
  // Initilize Apple Sign in
  const clientId = document.querySelector("meta[name='appleid-signin-client-id']").getAttribute("content"),
   redirectURI = document.querySelector("meta[name='appleid-signin-redirect-uri']").getAttribute("content");
  loadAppleAuth(clientId, redirectURI);
  const appleBtnContainer = document.getElementById("apple-btn-container");
  if (appleBtnContainer){
    appleBtnContainer.addEventListener("click", function () {
      AppleID.auth.signIn()
    });
  }
  document.addEventListener('AppleIDSignInOnSuccess', async (data) => {
    const appleBtn = document.getElementById("apple-btn-container");
    if ( appleBtn.dataset.eventName === 'logInWithApple') {
      logInWithApple(data.detail.authorization, appleBtn.dataset.verificationUri, appleBtn.dataset.returnUri)
    }
    else if (appleBtn.dataset.eventName === 'createLeadWithApple') {
      createLeadWithApple(data.detail.authorization, appleBtn.dataset.eventName , appleBtn.dataset.verificationUri, appleBtn.dataset.returnUri, appleBtn.dataset.formLocation, appleBtn.dataset.page)
    }
    else if (appleBtn.dataset.eventName === 'unlockContentWithApple') {
      unlockContentWithApple(data.detail.authorization, appleBtn.dataset.verificationUri, appleBtn.dataset.leadType, appleBtn.dataset.formLocation, appleBtn.dataset.page)
    }
  });
});

/* Load the Apple API */
const loadAppleAuth = function (clientId, redirectURI) {
  AppleID.auth.init({
    clientId: clientId,
    scope : 'name email',
    redirectURI : redirectURI,
    usePopup: true,
  });
}

/* Event listener for logging in with Apple */
async function logInWithApple(appleUser, redirectUri, returningUri) {
  const appleBtnContainer = document.getElementById("apple-btn-container");
  await oauthButtonHandler({
    idToken: appleUser.id_token,
    verificationUri: redirectUri,
    verificationExtras: {
      'returning_url': returningUri,
      'provider': 'apple'
    }
  });
}

/* Event listener for unlocking an article with Apple */
async function unlockContentWithApple(appleUser, verificationUri, leadType, formLocation, page) {
  const
    appleBtn = document.querySelector('#apple-btn-container'),
    optInCheckbox = appleBtn.closest('.read-this-article-immersive, .read-this-article, #immersive-article-modal').querySelector('.opt-in');
  await oauthButtonHandler({
    idToken: appleUser.id_token,
    verificationUri: verificationUri, // A rails route helper is attached to the button's data-redirect-uri attribute
    verificationExtras: {
      'article_id': currentPage.articleId,
      'lead_type': leadType,
      'form_location': formLocation,
      'page': page,
      'briefing_guid': currentPage.briefingGuid, // a user can unlock an article or a briefing
      'declined_opt_in': optInCheckbox ? optInCheckbox.checked == false : false,
      'opt_in_required': !!optInCheckbox,
      'provider': 'apple'
    }
  });
}

/* Event listener for Sign Up with Apple */
async function createLeadWithApple(appleUser, leadType, verificationUri, returningUri, formLocation, page) {
  const
    appleBtn = document.querySelector('#apple-btn-container'),
    optInCheckbox = appleBtn.closest('.locked, .read-this-article-immersive, .read-this-article, #immersive-article-modal, .ti-static, .newsletter-landing, #newsletters').querySelector('.opt-in');
  await oauthButtonHandler({
    idToken: appleUser.id_token,
    verificationUri: verificationUri,
    verificationExtras: {
      'declined_opt_in': optInCheckbox ? optInCheckbox.checked == false : false,
      'lead_type': leadType,
      'form_location': formLocation,
      'page': page,
      'returning_uri': returningUri,
      'opt_in_required': !!optInCheckbox,
      'provider': 'apple'
    },
  });
}

export { logInWithApple, createLeadWithApple, unlockContentWithApple }
